//#region src/semVer.ts
function e(e, n) {
	return t(e), t(n), e.localeCompare(n, void 0, { numeric: !0 });
}
function t(e) {
	if (e.split(".").length !== 3) throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
//#endregion
export { e as compareSemVer };

//# sourceMappingURL=index.js.map